
define('ldsh!modules/form_editor/templates/input_hidden', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (labelVisible) { ;
__p += '\n  <div class="form-control form-hidden-control">' +
((__t = ( nameAttr )) == null ? '' : __t) +
' (' +
((__t = ( labelText )) == null ? '' : __t) +
')</div>\n';
 } ;
__p += '\n<div class="col-sm-9 js-control">\n  <input type="hidden"\n    data-querymap="' +
((__t = ( variable )) == null ? '' : __t) +
'"\n    data-fb-login="' +
((__t = ( socialBinding )) == null ? '' : __t) +
'"\n    name="' +
((__t = ( nameAttr )) == null ? '' : __t) +
'"\n    class="form-control"\n    value="' +
((__t = ( value )) == null ? '' : __t) +
'" />\n</div>\n';

}
return __p
};});

